import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, Subject } from "rxjs";
import { AgencySupplierRightsdata, AgencySupplierRightsList } from "../Models/SuppliersProperties";
import { SuppliersService } from "../Services/suppliers.service";
@Component({
  selector: 'app-agency-supplier-rights',
  templateUrl: './agency-supplier-rights.component.html',
  styleUrls: ['./agency-supplier-rights.component.css']
})
/** AgencySupplierRights component*/
export class AgencySupplierRightsComponent {
  constructor(private supplierService: SuppliersService, private router: Router) { }
  agencyRightData = new AgencySupplierRightsdata();

  ngOnInit() {
    this.GetBaseData();
  }
  GetBaseData() {
    this.supplierService.GetSuppliersByParent(localStorage.getItem("AgencyId")).subscribe((data) => {
      this.agencyRightData = data;
      //for (let i = 0; i < this.agencyRightData.dataList.length; i++) {
      //  for (let j = 0; j < this.agencyRightData.dataList[i].supplierOficeIdlist.length; j++) {
      //  }
      //}
    })
  }

  SaveData() {
    try {
      let userId = 0;
      let agencyId = ""
      if (localStorage.getItem("AgencyId") != undefined && localStorage.getItem("AgencyId") != ""
        && localStorage.getItem("AgencyId") != null)
        agencyId = (localStorage.getItem("AgencyId"));
      if (localStorage.getItem("UserId") != undefined && localStorage.getItem("UserId") != null) {
        userId = Number(localStorage.getItem("UserId"))
        if (userId != 0) {
          let dataObj = new AgencySupplierRightsdata();
          for (let i = 0; i < this.agencyRightData.dataList.length; i++) {
            let listItem = this.agencyRightData.dataList[i];
            if (listItem.supplierRights.status != false) {
              let obj = new AgencySupplierRightsList();
              obj.name = listItem.name;
              obj.supplierId = listItem.supplierId;
              obj.selectedOficeIds = listItem.selectedOficeIds;
              obj.supplierRights = listItem.supplierRights;
              obj.creationUser = 1;
              obj.agency_Branch = localStorage.getItem("AgencyId");
              dataObj.dataList.push(obj);
            }
          }
          this.supplierService.CreateAgencySupplierRights(dataObj).subscribe((data) => {
            //console.log(data);
          })
        }
      }
    }
    catch (e) { }
  }

}
